import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Modal, { default as ModalStep } from 'components/Modal';
import { useEffect, useState } from 'react';
import { Button, Modal as ModalComp, useAuth, useMutation, useQuery, useToast } from '@webapps/reactjs-tech-components';
import { Grid, Tooltip } from '@material-ui/core';
import { Mail, Phone, Send, Cake } from '@material-ui/icons';
import MessageBox from 'components/MessageBox';
import { withStyles } from '@material-ui/styles';
import { ageCalculator } from '@webapps/utils';
import Information from 'components/Icons/Information';
import { formatPhoneNumber } from 'react-phone-number-input';

const Contact = ({ info }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [openMessageBox, setOpenMessageBox] = useState(false);
  const userid = info?.id;

  const handleOpenMessageBox = () => {
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  return (
    <div className={cx(classes.container)}>
      <div className={cx(global.title, classes.title)}>
        <FormattedMessage id="student.profil.contact.title" />
      </div>
      {!info?.email?.length ? (
        <div
          className={cx(css({
            textAlign: 'center',
            marginTop: spacing(2),
          }), global.infoText)}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <div
          className={css({
            width: '100%',
            marginTop: spacing(1),
            marginBottom: spacing(2),
          })}
        >
          <div className={cx(global.infoText, classes.address)}>
            <div style={{ display: 'flex', alignItems: "left" }}>
              <Cake className={global.smallIcon} />
              <div >Age :</div>
            </div>
            <div
              className={classes.phone}
            >
              {info?.birthDate ? `${ageCalculator(info?.birthDate)} ans` : 'Non renseigné'}
            </div>
          </div>
          <div className={cx(global.infoText, classes.address)}>
            <div style={{ display: 'flex' }}>
              <Mail className={global.smallIcon} />
              <div >Adresse e-mail :</div>
            </div>
            <a
              className={classes.phone}
              href={`mailto:${info?.email}`}
              rel="noreferrer"
              target="_blank"
            >
              {info?.email}
            </a>
          </div>
          <div className={cx(global.infoText, classes.address)}>
            <div style={{ display: 'flex' }}>
              <Phone className={global.smallIcon} />
              <div >Numéro de téléphone :</div>
            </div>
            <a className={classes.phone}>
              {info?.phone ? formatPhoneNumber(info?.phone) : 'Non renseigné'}
            </a>
          </div>
        </div>
      )}
      <Grid className={classes.ButtonContainer} container >
        <Grid item xs={6} sm={6}>
          <Button
            className={css({ borderRadius: 20, backgroundColor: 'white' })}
            color="primary"
            fullWidth
            onClick={handleOpenMessageBox}
            variant="outlined"
          >
            <Send style={{ fontSize: '15.0px', marginRight: spacing(1.25) }} /> Contacter
          </Button>
        </Grid>
      </Grid>
      <ModalComp
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({display: 'flex', flexDirection: 'row'})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
          Envoyez un message aux candidats et gardez contact dans votre
          messagerie
          </div>
        </div>
        <MessageBox id={userid} onCancel={handleCloseMessageBox} />
      </ModalComp>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'column',
    marginTop: spacing(2.5),
  },
  title: {
    borderLeft: '3px solid #0060F9',
    lineHeight: '100%',
    paddingLeft: spacing(1),
    marginBottom: spacing(1.5)
  },
  infoContainer: {
    display: 'flex',
  },
  address: {
    display: 'flex',
    alignItems: 'flex-start',
    marginTop: spacing(0.5),
    '@media (max-width: 430px)': {
      flexDirection: 'column'
    }
  },
  phone: {
    color: '#152652',
    marginLeft: spacing(1),
    textDecoration: 'none',
    '@media (max-width: 430px)': {
      marginLeft: spacing(0),
    }
  },
  gridBtn2: {
    '@media (max-width: 839px)': {
      marginTop: spacing(1),
      display: 'flex',
      justifyContent: 'flex-end',
    }
  },
  ButtonContainer: {
    display: 'flex',
    alignItems: 'start',
    '@media (max-width: 839px)': {
      justifyContent: 'start'
    },
    '@media (min-width: 840px) and (max-width: 1024px)': {
      justifyContent: 'start'
    }
  },
  buttonSendAff: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 639px)': {
      marginTop: spacing(1)
    },
    '& button': {
      '@media (min-width: 639px)': {
        marginLeft: spacing(2)
      }
    }
  }
});

Contact.propTypes = {
  info: PropTypes.object,
};

export default Contact;
